import React from 'react';

export const Search = (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z'
            fill='black'
            fillOpacity='0.54'
        />
    </svg>
);

export const CalendarDate = (
    <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M5.75 9H3.83333V11H5.75V9ZM9.58333 9H7.66667V11H9.58333V9ZM13.4167 9H11.5V11H13.4167V9ZM15.3333 2H14.375V0H12.4583V2H4.79167V0H2.875V2H1.91667C0.852917 2 0.00958332 2.9 0.00958332 4L0 18C0 19.1 0.852917 20 1.91667 20H15.3333C16.3875 20 17.25 19.1 17.25 18V4C17.25 2.9 16.3875 2 15.3333 2ZM15.3333 18H1.91667V7H15.3333V18Z'
            fill='black'
            fillOpacity='0.54'
        />
    </svg>
);

export const ArrowDownwardFilled = (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M12 6L10.9425 4.9425L6.75 9.1275V0H5.25V9.1275L1.065 4.935L0 6L6 12L12 6Z'
            fill='black'
            fillOpacity='0.54'
        />
    </svg>
);

export const ArOutline = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_776_6860)'>
            <path
                d='M2.00033 2.66663C2.00033 2.29996 2.30033 1.99996 2.66699 1.99996H4.00033V0.666626H2.66699C1.56033 0.666626 0.666992 1.55996 0.666992 2.66663V3.99996H2.00033V2.66663Z'
                fill='currentColor'
            />
            <path
                d='M2.00033 13.3333V12H0.666992V13.3333C0.666992 14.44 1.56033 15.3333 2.66699 15.3333H4.00033V14H2.66699C2.30033 14 2.00033 13.7 2.00033 13.3333Z'
                fill='currentColor'
            />
            <path
                d='M13.3333 0.666626H12V1.99996H13.3333C13.7 1.99996 14 2.29996 14 2.66663V3.99996H15.3333V2.66663C15.3333 1.55996 14.44 0.666626 13.3333 0.666626Z'
                fill='currentColor'
            />
            <path
                d='M14 13.3333C14 13.7 13.7 14 13.3333 14H12V15.3333H13.3333C14.44 15.3333 15.3333 14.44 15.3333 13.3333V12H14V13.3333Z'
                fill='currentColor'
            />
            <path
                d='M12.6673 9.91325V6.08659C12.6673 5.60659 12.414 5.16659 12.0007 4.93325L8.66732 3.01325C8.46065 2.89325 8.23398 2.83325 8.00065 2.83325C7.76732 2.83325 7.54065 2.89325 7.33398 3.01325L4.00065 4.92658C3.58732 5.16658 3.33398 5.60659 3.33398 6.08659V9.91325C3.33398 10.3933 3.58732 10.8333 4.00065 11.0666L7.33398 12.9866C7.54065 13.1066 7.76732 13.1666 8.00065 13.1666C8.23398 13.1666 8.46065 13.1066 8.66732 12.9866L12.0007 11.0666C12.414 10.8333 12.6673 10.3933 12.6673 9.91325ZM7.33398 11.4466L4.66732 9.91325V6.82658L7.33398 8.37992V11.4466ZM8.00065 7.22658L5.36065 5.68658L8.00065 4.16659L10.6407 5.68658L8.00065 7.22658ZM11.334 9.91325L8.66732 11.4466V8.37992L11.334 6.82658V9.91325Z'
                fill='currentColor'
            />
        </g>
        <defs>
            <clipPath id='clip0_776_6860'>
                <rect width='16' height='16' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export const Insights = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M4.66667 13.3333H7.33333C7.33333 14.0667 6.73333 14.6667 6 14.6667C5.26667 14.6667 4.66667 14.0667 4.66667 13.3333ZM3.33333 12.6667H8.66667V11.3333H3.33333V12.6667ZM11 6.33333C11 8.88 9.22667 10.24 8.48667 10.6667H3.51333C2.77333 10.24 1 8.88 1 6.33333C1 3.57333 3.24 1.33333 6 1.33333C8.76 1.33333 11 3.57333 11 6.33333ZM9.66667 6.33333C9.66667 4.31333 8.02 2.66667 6 2.66667C3.98 2.66667 2.33333 4.31333 2.33333 6.33333C2.33333 7.98 3.32667 8.92667 3.9 9.33333H8.1C8.67333 8.92667 9.66667 7.98 9.66667 6.33333ZM14.2467 4.91333L13.3333 5.33333L14.2467 5.75333L14.6667 6.66667L15.0867 5.75333L16 5.33333L15.0867 4.91333L14.6667 4L14.2467 4.91333ZM12.6667 4L13.2933 2.62667L14.6667 2L13.2933 1.37333L12.6667 0L12.04 1.37333L10.6667 2L12.04 2.62667L12.6667 4Z'
            fill='#111827'
        />
    </svg>
);
export const OpenBox = (
    <svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M-6.16331e-08 6.00016L1.41 7.41016L6 2.83016L10.59 7.41016L12 6.00016L6 0.00015614L-6.16331e-08 6.00016Z'
            fill='black'
            fill-opacity='0.54'
        />
    </svg>
);

export const CloseBox = (
    <svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M12 1.41L10.59 0L6 4.58L1.41 0L0 1.41L6 7.41L12 1.41Z' fill='black' fill-opacity='0.54' />
    </svg>
);

export const Download = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M8 10V2' stroke='#1E99FD' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round' />
        <path
            d='M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M4.66699 6.66675L8.00033 10.0001L11.3337 6.66675'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
    </svg>
);

export const Upload = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M8 2V10' stroke='#1E99FD' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round' />
        <path
            d='M11.3334 5.33333L8.00008 2L4.66675 5.33333'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
    </svg>
);

export const SignalStrength = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M1.33325 13.3333H1.33992'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M4.66675 13.3334V10.6667'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path d='M8 13.3333V8' stroke='#1E99FD' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round' />
        <path
            d='M11.3333 13.3333V5.33325'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M14.6667 2.66675V13.3334'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
    </svg>
);

export const ChannelNumber = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M10.8313 5.17407C11.58 5.92402 12.0004 6.9404 12.0004 8.00007C12.0004 9.05975 11.58 10.0761 10.8313 10.8261'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M12.7166 3.28857C13.9651 4.5386 14.6665 6.23313 14.6665 7.99991C14.6665 9.76669 13.9651 11.4612 12.7166 12.7112'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M3.28341 12.7112C2.03482 11.4612 1.3335 9.76669 1.3335 7.99991C1.3335 6.23313 2.03482 4.5386 3.28341 3.28857'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M5.16866 10.8261C4.42 10.0761 3.99951 9.05975 3.99951 8.00007C3.99951 6.9404 4.42 5.92402 5.16866 5.17407'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M8.00008 9.33341C8.73646 9.33341 9.33341 8.73646 9.33341 8.00008C9.33341 7.2637 8.73646 6.66675 8.00008 6.66675C7.2637 6.66675 6.66675 7.2637 6.66675 8.00008C6.66675 8.73646 7.2637 9.33341 8.00008 9.33341Z'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
    </svg>
);

export const LiveSession = (
    <svg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M14 5L18 2V14L14 11V5ZM12 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H12C13.1 16 14 15.1 14 14V2C14 0.9 13.1 0 12 0ZM12 14H2V2H12V14Z'
            fill='currentColor'
        />
    </svg>
);

export const ConnectedDevices = (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M10.6666 14V12.6667C10.6666 11.9594 10.3856 11.2811 9.88554 10.781C9.38544 10.281 8.70716 10 7.99992 10H3.99992C3.29267 10 2.6144 10.281 2.1143 10.781C1.6142 11.2811 1.33325 11.9594 1.33325 12.6667V14'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M10.6667 2.08545C11.2386 2.2337 11.745 2.56763 12.1065 3.03482C12.4681 3.50202 12.6642 4.07604 12.6642 4.66678C12.6642 5.25752 12.4681 5.83154 12.1065 6.29874C11.745 6.76594 11.2386 7.09987 10.6667 7.24812'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M14.6667 14V12.6667C14.6663 12.0758 14.4697 11.5019 14.1077 11.0349C13.7457 10.5679 13.2388 10.2344 12.6667 10.0867'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M5.99992 7.33333C7.47268 7.33333 8.66659 6.13943 8.66659 4.66667C8.66659 3.19391 7.47268 2 5.99992 2C4.52716 2 3.33325 3.19391 3.33325 4.66667C3.33325 6.13943 4.52716 7.33333 5.99992 7.33333Z'
            stroke='#1E99FD'
            stroke-width='1.33333'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
    </svg>
);
